export default __webpack_public_path__ + "static/media/logol.c8da7dc7.png";